/* ============================================================
   Earth Energy — Buy Box v2.1 controller
   Purchase toggle (One-Time / Subscribe) on top + side-by-side
   size cards that re-price by mode + subscribe benefits + live
   delivery-date estimate + low-stock notice. Shop Pay dynamic
   checkout. ALL prices come from data-* rendered LIVE by Liquid.
   Keeps hidden form inputs (id / selling_plan) synced so the native
   {{ form | payment_button }} Shop Pay button checks out the selection.
   ============================================================ */
(function(){
  function money(v){ return parseFloat(String(v).replace(/[^0-9.\-]/g,'')) || 0; }
  function fmt(sample, value){
    var m = String(sample||'$0').match(/^([^\d\-]*)([\d.,]+)(.*)$/);
    var pre = m ? m[1] : '$', suf = m ? m[3] : '';
    return pre + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suf;
  }

  /* ---------- open cart drawer (theme-agnostic) ---------- */
  function tryDrawer(root){
    var sels=[]; var custom=root&&root.getAttribute('data-cart-selector'); if(custom) sels.push(custom);
    try{ var cd=document.querySelector('cart-drawer'); if(cd&&typeof cd.open==='function'){ cd.open(); return true; } }catch(e){}
    sels=sels.concat(['[data-cart-drawer-toggle]','[data-drawer="cart"]','button[aria-controls="CartDrawer"]','a[aria-controls="CartDrawer"]','.js-drawer-open-cart','.js-cart-trigger','.cart-drawer-toggle','[data-cart-toggle]','[data-action="open-cart"]','#cart-icon-bubble']);
    for(var i=0;i<sels.length;i++){ try{ var el=document.querySelector(sels[i]); if(el){ el.click(); return true; } }catch(e){} }
    return false;
  }
  function openCart(root){
    var action=(root&&root.getAttribute('data-cart-action'))||'drawer';
    if(action==='cart'||action==='page'){ window.location.href='/cart'; return; }
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      ['cart:refresh','cart:updated','cart-updated','ajaxCart:afterCartLoad','cart:build','theme:cart:reload','cart:open','cart:added','ajaxProduct:added'].forEach(function(n){ try{ document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart}})); }catch(e){} });
      try{ document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart}})); }catch(e){}
      if(!tryDrawer(root)){ window.location.href='/cart'; }
    }).catch(function(){ window.location.href='/cart'; });
  }

  function initBuy2(box){
    if(box.dataset.b2Init==='1') return; box.dataset.b2Init='1';
    var root = box.closest('.ee-pdp') || document;

    var cards    = [].slice.call(box.querySelectorAll('.b2-size'));
    var toggles  = [].slice.call(box.querySelectorAll('.b2-tg'));
    var flavorBtns = [].slice.call(box.querySelectorAll('.b2-flavor button'));
    var benefits = box.querySelector('.b2-benefits');
    var delivEl  = box.querySelector('.b2-delivdate');
    var atcMain  = box.querySelector('.b2-atc');
    var footEl   = box.querySelector('.b2-footline');
    var idInput  = box.querySelector('.js-variant-input');
    var planInput= box.querySelector('.js-plan-input'); /* may be absent; created on demand */

    var sticky     = document.querySelector('.ee-pdp-sticky');
    var stickyPrice= sticky ? sticky.querySelector('.st-price') : null;
    var stickyBtns = [].slice.call(document.querySelectorAll('.ee-pdp-sticky .js-atc'));
    var finalPrice = root.querySelector ? root.querySelector('.js-final-price') : null;
    var finalSub   = root.querySelector ? root.querySelector('.js-final-sub') : null;

    /* delivery defaults to ONE-TIME */
    var state = { size: null, delivery: 'onetime', flavor: 'unflav' };
    var pre = box.querySelector('.b2-size.sel');
    state.size = pre ? pre.getAttribute('data-size') : (cards[0] ? cards[0].getAttribute('data-size') : null);

    function card(){ for(var i=0;i<cards.length;i++){ if(cards[i].getAttribute('data-size')===state.size) return cards[i]; } return cards[0]; }
    // flavor-aware value lookup (only colostrum has a chocolate flavor; no-op elsewhere)
    function pick(c, base){
      var d=c.dataset;
      if(state.flavor==='choc' && d[base+'Choc']!=null && d[base+'Choc']!=='') return d[base+'Choc'];
      return d[base]||'';
    }
    function data(c){
      var one=pick(c,'onetime'), sub=pick(c,'sub'), rec=pick(c,'subRecur')||sub, comp=pick(c,'compare')||one;
      var variant = flavorBtns.length ? (state.flavor==='choc'?c.dataset.variantChoc:c.dataset.variantUnflav) : c.dataset.variant;
      return {
        one:money(one), sub:money(sub), rec:money(rec)||money(sub), comp:money(comp)||money(one),
        oneS:one, subS:sub||one, variant:variant||'', plan:c.dataset.plan||'',
        count:c.dataset.count||'', days:c.dataset.days||'', word:c.dataset.word||'servings', desc:c.dataset.desc||'', title:c.dataset.title||'',
        perLabel:c.dataset.perLabel||'', packs:parseInt(c.dataset.packs||'1',10)||1
      };
    }
    function unit1(){ return cards.length ? money(cards[0].dataset.onetime) : 0; }

    /* size card price block — reflects the selected mode (one-time / subscribe) */
    function renderCard(c){
      var o=data(c); var isSub=state.delivery==='subscribe';
      var now=c.querySelector('.b2-now'), was=c.querySelector('.b2-was'), per=c.querySelector('.b2-per'), save=c.querySelector('.b2-save');
      var total = isSub ? o.sub : o.one, perU = total / o.packs;
      if(now) now.textContent = fmt(o.oneS, total);
      if(was) was.style.display='none';
      if(per) per.textContent = fmt(o.oneS, perU) + (o.perLabel||'');
      if(save){ var b=unit1(); var pct=b>0?Math.round((b-perU)/b*100):0; if(pct>0){ save.textContent='SAVE '+pct+'%'; save.style.display=''; } else save.style.display='none'; }
    }

    /* live delivery-date estimate (min/max business-ish days, editable in settings) */
    function fmtDate(dt){ var D=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; return D[dt.getDay()]+', '+M[dt.getMonth()]+' '+dt.getDate(); }
    function renderDeliveryDate(){
      if(!delivEl) return;
      var mn=parseInt(box.getAttribute('data-deliv-min'),10); if(isNaN(mn)) mn=3;
      var mx=parseInt(box.getAttribute('data-deliv-max'),10); if(isNaN(mx)) mx=6;
      var a=new Date(); a.setDate(a.getDate()+mn); var b=new Date(); b.setDate(b.getDate()+mx);
      delivEl.innerHTML='🚚 Order now for delivery by: <b>'+fmtDate(a)+' – '+fmtDate(b)+'</b>';
    }

    function syncForm(o, isSub){
      if(idInput) idInput.value = o.variant || '';
      if(isSub && o.plan){
        if(!planInput){ planInput=document.createElement('input'); planInput.type='hidden'; planInput.name='selling_plan'; planInput.className='js-plan-input'; (idInput?idInput.parentNode:box).insertBefore(planInput, idInput?idInput.nextSibling:null); }
        planInput.disabled=false; planInput.value=o.plan;
      } else if(planInput){ planInput.value=''; planInput.disabled=true; }
    }

    function render(){
      toggles.forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-del')===state.delivery); });
      cards.forEach(function(c){ c.classList.toggle('sel', c.getAttribute('data-size')===state.size); renderCard(c); });
      if(benefits) benefits.hidden = (state.delivery!=='subscribe');
      var o=data(card()); var isSub=state.delivery==='subscribe';
      var priceVal = isSub ? o.sub : o.one;
      if(atcMain){ var ap=atcMain.querySelector('.atc-price'); if(ap) ap.textContent = fmt(o.oneS, priceVal); }
      if(footEl && o.count){ footEl.textContent = o.count+' '+o.word+' · '+o.days+'-day supply · '+String(o.desc).replace(/&amp;/g,'&'); }
      if(stickyPrice) stickyPrice.textContent = o.title+' · '+fmt(o.oneS, priceVal);
      if(finalPrice) finalPrice.textContent = fmt(o.oneS, priceVal);
      if(finalSub) finalSub.textContent = o.title+' · '+o.days+'-day supply'+(isSub?' · Subscribe & Save':'');
      syncForm(o, isSub);
    }

    /* events */
    var sizesWrap = box.querySelector('.b2-sizes');
    if(sizesWrap) sizesWrap.addEventListener('click', function(e){ var c=e.target.closest('.b2-size'); if(c){ state.size=c.getAttribute('data-size'); render(); } });
    toggles.forEach(function(t){ t.addEventListener('click', function(){ state.delivery=t.getAttribute('data-del'); render(); }); });
    flavorBtns.forEach(function(b){ b.addEventListener('click', function(){ flavorBtns.forEach(function(x){ x.classList.remove('active'); }); b.classList.add('active'); state.flavor=b.getAttribute('data-flavor'); render(); }); });

    /* add to cart (AJAX) with drawer-open + re-add reset */
    function addToCart(btn){
      var o=data(card()); var isSub=state.delivery==='subscribe';
      if(!o.variant){ var o0=btn.innerHTML; btn.textContent='Added ✓'; setTimeout(function(){ btn.innerHTML=o0; render(); },1400); return; }
      if(box.getAttribute('data-cart-mode')==='permalink'){
        btn.disabled=true; btn.dataset.busy='1'; btn.textContent='Adding…';
        window.location.href='/cart/'+encodeURIComponent(o.variant)+':1'+((isSub&&o.plan)?('?selling_plan='+encodeURIComponent(o.plan)):'');
        return;
      }
      var item={ id:o.variant, quantity:1 }; if(isSub && o.plan){ item.selling_plan=o.plan; }
      var orig=btn.innerHTML; btn.disabled=true; btn.dataset.busy='1'; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
        .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
        .then(function(){ btn.textContent='Added ✓'; openCart(root); setTimeout(function(){ btn.disabled=false; btn.removeAttribute('data-busy'); btn.innerHTML=orig; render(); },1300); })
        .catch(function(err){ try{ console.error('[ee-buy3] add-to-cart failed, using cart permalink fallback:', err); }catch(e){} btn.textContent='Adding…'; var url='/cart/'+encodeURIComponent(o.variant)+':1'+((isSub&&o.plan)?('?selling_plan='+encodeURIComponent(o.plan)):''); window.location.href=url; });
    }
    if(atcMain) atcMain.addEventListener('click', function(){ if(atcMain.dataset.busy!=='1') addToCart(atcMain); });
    stickyBtns.forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); if(b.dataset.busy!=='1') addToCart(b); }); });

    renderDeliveryDate();
    render();
  }

  function boot(){ document.querySelectorAll('.ee-buy3').forEach(initBuy2); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
